/**
 * Created by roman.kupin on 10/3/2017.
 */
import PropertyApiActions from "../../../../../actions/propertyApi";
import PrestayApiActions from "../../../../../actions/api/prestayApi";
import PoststayApiActions from "../../../../../actions/api/poststayApi";
import PhotoAdvocacyApiActions from "../../../../../actions/api/photoAdvocacyApi";

export const PREFIX = "[GuestsJourneys]";
export const INITIALIZED = `${PREFIX}.Initialized`;

export function fetchJourneysData(propertyUuid, startDate?, endDate?) {
    return dispatch => {
        return Promise.all([
            dispatch(PropertyApiActions.getAdvocacyGuestJourney(propertyUuid)),
            dispatch(PropertyApiActions.getPlatformLayersData(propertyUuid)),
            dispatch(PrestayApiActions.getCampaigns(propertyUuid, startDate, endDate)),
            dispatch(PoststayApiActions.getCampaigns(propertyUuid, startDate, endDate)),
            dispatch(PhotoAdvocacyApiActions.getCampaigns(propertyUuid, startDate, endDate))
        ]);
    }
}

export function initialized(isInitialized) {
    return dispatch => {
        dispatch({type: INITIALIZED, payload: isInitialized});
    }
}

export function dateRangeChange(propertyUuid, startDate, endDate) {
    return (dispatch, getState) => {
        return Promise.all([
            dispatch(PrestayApiActions.getCampaigns(propertyUuid, startDate, endDate)),
            dispatch(PoststayApiActions.getCampaigns(propertyUuid, startDate, endDate)),
            dispatch(PhotoAdvocacyApiActions.getCampaigns(propertyUuid, startDate, endDate))
        ]);
    };
}

const layersTypes = {"prestay": 1, "poststay": 4, "homepage": 2, "quotelist": 3, "groupadvocacy": 5, "photocontest": 6};

export function addLayer(companyUuid, propertyUuid, layerName) {
    return (dispatch, getState, {Layers}) => {
        Layers.create({companyId: companyUuid, propertyId: propertyUuid}, layersTypes[layerName])
            .then(() => {
                dispatch(initialized(false));
                dispatch(fetchJourneysData(propertyUuid)).then(() => dispatch(initialized(true)));
            });
    };
}
const All = {fetchJourneysData, initialized, dateRangeChange, layersTypes, addLayer};
export default All;